<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'
import { filtersRichtext, textLenHandler } from '@/utils/common'

export default {
  name: 'Comp53',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor, filtersRichtext, textLenHandler,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-53">
    <module-title :title="moduleOption.title" margin-bottom="38" />
    <div class="comp-transverse-3 modules-id-53-content">
      <div
        v-for="(v, i) in moduleOption.list.slice(0, 4)"
        :key="`modules-id-53-item-${i}`"
        class="item"
        :class="`item-${i + 1}`"
        @click="onModuleItem(v)"
      >
        <p class="item-headline">{{ textLenHandler(v.headline, 4) }}</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-53-content {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .item {
    width: 347px;
    height: 99px;
    display: flex;
    justify-content: center;
    align-items: center;
    .item-headline {
      width: 160px;
      font-size: 30px;
      font-family: siyuansong;
      font-weight: bold;
      color: #fff;
    }
  }
  .item-1 {
    background: url('~imgs/modules/comp53-bg1.png') no-repeat center;
    background-size: 100% 100%;
    .item-headline {
      margin: 20px 0 0 50px;
    }
  }
  .item-2 {
    background: url('~imgs/modules/comp53-bg2.png') no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    top: 78px;
    .item-headline {
      margin: 10px 0 0 50px;
    }
  }
  .item-3 {
    background: url('~imgs/modules/comp53-bg3.png') no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    top: 146px;
    .item-headline {
      margin: 20px 0 0 50px;
    }
  }
  .item-4 {
    background: url('~imgs/modules/comp53-bg4.webp') no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    top: 224px;
    .item-headline {
      margin: 12px 0 0 50px;
    }
  }
}
</style>
